/* =============================================
   QUEST MYSTERY BOXES — THEME JAVASCRIPT
   ============================================= */

(function () {
  'use strict';

  /* ── Countdown Timer ── */
  function initCountdown() {
    const el = document.getElementById('quest-countdown');
    if (!el) return;

    const target = new Date('April 1, 2026 00:00:00').getTime();

    function update() {
      const now  = Date.now();
      const diff = target - now;

      if (diff <= 0) {
        el.innerHTML = '<span class="countdown-unit"><span class="countdown-unit__number">00</span><span class="countdown-unit__label">Days</span></span>';
        return;
      }

      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      function pad(n) { return String(n).padStart(2, '0'); }

      document.getElementById('cd-days').textContent    = pad(days);
      document.getElementById('cd-hours').textContent   = pad(hours);
      document.getElementById('cd-minutes').textContent = pad(minutes);
      document.getElementById('cd-seconds').textContent = pad(seconds);
    }

    update();
    setInterval(update, 1000);
  }

  /* ── Cookie Consent ── */
  function initCookieBanner() {
    const banner  = document.getElementById('cookie-banner');
    const accept  = document.getElementById('cookie-accept');
    const decline = document.getElementById('cookie-decline');
    if (!banner) return;

    if (!localStorage.getItem('quest_cookie_consent')) {
      banner.style.display = 'block';
    }

    if (accept) {
      accept.addEventListener('click', function () {
        localStorage.setItem('quest_cookie_consent', 'accepted');
        banner.style.display = 'none';
      });
    }
    if (decline) {
      decline.addEventListener('click', function () {
        localStorage.setItem('quest_cookie_consent', 'declined');
        banner.style.display = 'none';
      });
    }
  }

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    const hamburger = document.getElementById('hamburger');
    const mobileNav = document.getElementById('mobile-nav');
    if (!hamburger || !mobileNav) return;

    hamburger.addEventListener('click', function () {
      const open = mobileNav.style.display === 'flex';
      mobileNav.style.display = open ? 'none' : 'flex';
      hamburger.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ── Smooth scroll for anchor links ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Scroll-triggered fade-in ── */
  function initScrollReveal() {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Header shadow on scroll ── */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.5)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ── Add to cart flash feedback ── */
  function initCartFeedback() {
    document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
      btn.closest('form').addEventListener('submit', function () {
        btn.textContent = 'Adding…';
      });
    });
  }

  /* ── Init all ── */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initCookieBanner();
    initMobileMenu();
    initSmoothScroll();
    initScrollReveal();
    initHeaderScroll();
    initCartFeedback();
  });
})();
